import {type GatewayConfiguration} from '../../models/GatewayConfiguration';
import {$qsAll} from '../../../../@shared/ts/dom';
import {startModalProcessing, stopModalLoading} from '../../reducers/environmentReducer';
import {store} from '../../store';
import {displayPaymentErrorMessage, type OrderService} from '../order';
import {setupFreeOrderButton} from './button';
import {getErrorString} from '../../../../@shared/ts/error';
import {getLocaleText} from '../../util/translation';
import {PeachPayOrder} from '../../reducers/peachPayOrderReducer';

export function initFreeOrderSupport(orderService: OrderService) {
	const confirm = async (event: MouseEvent) => {
		if (!await PeachPayOrder.reportValidity()) {
			return;
		}

		const $target = event.target as HTMLElement | null;
		const $button = $target?.closest<HTMLButtonElement>('button');
		if (!$button) {
			return;
		}

		await freeOrderFlow(orderService);
	};

	$qsAll<HTMLElement>('.free-btn', $el => {
		$el.addEventListener('click', confirm);
	});

	setupFreeOrderButton();
}

export function getFreeMethodConfiguration(): GatewayConfiguration {
	return {
		name: 'PeachPay Free',
		description: '',
		gatewayId: 'peachpay_free',
		assets: {
			badge: {src: ''},
		},
	};
}

async function freeOrderFlow(orderService: OrderService) {
	store.dispatch(startModalProcessing());

	const {error: transactionError, result: transaction} = await orderService.startTransaction('peachpay_free');
	if (transactionError || !transaction) {
		const errorMessage = transactionError ? getErrorString(transactionError) : getLocaleText('An unknown error occured while starting the transaction. Please refresh the page and try again.');
		displayPaymentErrorMessage(errorMessage);

		store.dispatch(stopModalLoading());
		return;
	}

	const {error: orderError, result: orderResult} = await orderService.placeOrder(transaction);
	if (orderError || !orderResult || orderResult.result !== 'success') {
		store.dispatch(stopModalLoading());
		return;
	}

	if (window.top) {
		await transaction.complete({paymentStatus: 'success', orderStatus: 'success'});
		window.top.location = orderResult.redirect;
	}
}
